export default __webpack_public_path__ + "static/media/1.e0ab7689.png";